import React from 'react';

const ApiWebhookForm = ({ formData, setFormData }) => {
  return (
    <div className="space-y-6">
      <div>
        <label className="block text-gray-700 font-medium mb-2">
          Integration Name <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          className="w-full border border-gray-300 rounded-md p-2"
          placeholder="My Webhook Integration"
          value={formData.name || ''}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
      </div>

      <div>
        <label className="block text-gray-700 font-medium mb-2">
          Webhook Endpoint <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          className="w-full border border-gray-300 rounded-md p-2"
          placeholder="https://api.example.com/webhook"
          value={formData.webhook_endpoint || ''}
          onChange={(e) => setFormData({ ...formData, webhook_endpoint: e.target.value })}
        />
      </div>

      <div>
        <label className="block text-gray-700 font-medium mb-2">
          Access Token <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          className="w-full border border-gray-300 rounded-md p-2"
          placeholder="Your Access Token"
          value={formData.access_token || ''}
          onChange={(e) => setFormData({ ...formData, access_token: e.target.value })}
        />
      </div>
    </div>
  );
};

export default ApiWebhookForm;

